/**
 * Opening hours as the API sends them: a list of slots, each one a day of the
 * week (ISO, 1 for Monday to 7 for Sunday) and the `HH:MM` it opens and
 * closes that day. A day with no slot is a day the shop is closed.
 */

export const WEEK_DAYS = [
  { value: 1, label: 'Lundi' },
  { value: 2, label: 'Mardi' },
  { value: 3, label: 'Mercredi' },
  { value: 4, label: 'Jeudi' },
  { value: 5, label: 'Vendredi' },
  { value: 6, label: 'Samedi' },
  { value: 7, label: 'Dimanche' },
];

/** Today as an ISO day number, in the reader's own clock. */
export function isoToday(date = new Date()) {
  return ((date.getDay() + 6) % 7) + 1;
}

/** `09:00 – 12:30`, the way a shopfront writes it. */
export function formatSlot({ opens, closes }) {
  return `${opens} – ${closes}`;
}

/** The seven days in order, each with its slots (none: closed). */
export function groupByDay(slots) {
  return WEEK_DAYS.map(({ value, label }) => ({
    day: value,
    label,
    slots: (slots || [])
      .filter((slot) => slot.day === value)
      .sort((a, b) => a.opens.localeCompare(b.opens)),
  }));
}

/**
 * The slot "add an hour" proposes: the day after the last one entered, with
 * the commonest times, so filling a week is mostly changing nothing.
 */
export function nextSlot(slots) {
  const lastDay = slots.length > 0 ? Math.max(...slots.map((slot) => slot.day)) : 0;

  return { day: lastDay >= 7 ? 1 : lastDay + 1, opens: '09:00', closes: '18:00' };
}
